export const TABLE_FILTERS = {
  all: 'All',
  courses: 'Courses',
  attendanceStatuses: 'AttendanceStatuses',
  visibility: 'Visibility',
  courseStatuses: 'CourseStatuses',
  licenseStatuses: 'LicenseStatuses',
  packages: 'Package',
  userAccountStatus: 'UserAccountStatus',
  expirationStatuses: 'ExpirationStatuses',
  packageCategories: 'PackageCategories',
  search: 'Search',
};
